import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/bits";
import { Swords, Trophy, CheckCircle2 } from "lucide-react";

export default function Challenges() {
  const [challenges, setChallenges] = useState(null);

  const load = useCallback(() => api.get("/portal/challenges").then((r) => setChallenges(r.data)).catch((e) => toast.error(fmtErr(e))), []);
  useEffect(() => { load(); }, [load]);

  const join = async (id) => {
    try {
      const { data } = await api.post(`/portal/challenges/${id}/join`);
      toast.success(data.message);
      load();
    } catch (e) {
      toast.error(fmtErr(e));
    }
  };

  if (!challenges) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="challenges-page">
      <PageHeader title="التحديات الأسبوعية" sub="مسابقات تحفيزية يرسلها المدير العام — التفاعل معها جزء من معايير شهادة الشكر الشهرية" />

      {challenges.length === 0 ? (
        <EmptyState testid="challenges-empty" text="لا توجد تحديات حالياً — ترقّب تحدي هذا الأسبوع" />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {challenges.map((ch) => (
            <div key={ch.id} data-testid={`challenge-card-${ch.id.slice(0, 8)}`}
              className={`rounded-3xl p-6 border shadow-md ${ch.status === "active" ? "bg-turq-100 dark:bg-surface2 border-turq-300/50" : "bg-surface border-brd"}`}>
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${ch.status === "active" ? "bg-turq-900" : "bg-beige-900 dark:bg-surface2"}`}>
                  {ch.status === "active" ? <Swords className="w-5 h-5 text-white" /> : <Trophy className="w-5 h-5 text-turq-900 dark:text-turq-300" />}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <b className="font-head text-[15px]">{ch.title}</b>
                    <span className={`text-[10px] font-bold rounded-full px-2.5 py-0.5 ${ch.status === "active" ? "bg-coral-600 text-white" : "bg-beige-900/40 text-mutext"}`}>
                      {ch.status === "active" ? "نشط" : "مكتمل"}
                    </span>
                  </div>
                  <p className="text-xs text-mutext mt-1.5 leading-relaxed">{ch.description}</p>
                  <div className="text-[11px] text-mutext mt-2">{ch.week_start} → {ch.week_end} · {ch.participants_count} مشارك</div>
                  {ch.winner_school_name && (
                    <div data-testid={`challenge-winner-${ch.id.slice(0, 8)}`} className="mt-2 text-[11.5px] font-bold text-coral-900 dark:text-coral-300 flex items-center gap-1">
                      <Trophy className="w-3.5 h-3.5" /> الفائز: {ch.winner_school_name}
                    </div>
                  )}
                </div>
              </div>
              {ch.status === "active" && (
                <div className="mt-4 text-left">
                  {ch.joined ? (
                    <span data-testid={`challenge-joined-${ch.id.slice(0, 8)}`} className="inline-flex items-center gap-1.5 text-[11px] font-bold text-turq-900 dark:text-turq-300 bg-surface rounded-full px-4 py-2">
                      <CheckCircle2 className="w-3.5 h-3.5" /> أنت مشارك — بالتوفيق
                    </span>
                  ) : (
                    <button data-testid={`challenge-join-${ch.id.slice(0, 8)}`} onClick={() => join(ch.id)}
                      className="text-[11.5px] font-bold text-white bg-coral-600 hover:bg-coral-900 rounded-full px-5 py-2 transition-colors">
                      شارك في التحدي
                    </button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
